/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderDiscountSearchEssential } from './OrderDiscountSearchEssential';
import {
    OrderDiscountSearchEssentialFromJSON,
    OrderDiscountSearchEssentialFromJSONTyped,
    OrderDiscountSearchEssentialToJSON,
    OrderDiscountSearchEssentialToJSONTyped,
} from './OrderDiscountSearchEssential';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
    AddressToJSONTyped,
} from './Address';
import type { BusinessServiceAvailability } from './BusinessServiceAvailability';
import {
    BusinessServiceAvailabilityFromJSON,
    BusinessServiceAvailabilityFromJSONTyped,
    BusinessServiceAvailabilityToJSON,
    BusinessServiceAvailabilityToJSONTyped,
} from './BusinessServiceAvailability';
import type { PhoneNumber } from './PhoneNumber';
import {
    PhoneNumberFromJSON,
    PhoneNumberFromJSONTyped,
    PhoneNumberToJSON,
    PhoneNumberToJSONTyped,
} from './PhoneNumber';
import type { HandoffOptions } from './HandoffOptions';
import {
    HandoffOptionsFromJSON,
    HandoffOptionsFromJSONTyped,
    HandoffOptionsToJSON,
    HandoffOptionsToJSONTyped,
} from './HandoffOptions';
import type { MenuItemSearchEssential } from './MenuItemSearchEssential';
import {
    MenuItemSearchEssentialFromJSON,
    MenuItemSearchEssentialFromJSONTyped,
    MenuItemSearchEssentialToJSON,
    MenuItemSearchEssentialToJSONTyped,
} from './MenuItemSearchEssential';

/**
 * 
 * @export
 * @interface MerchantSearchResult
 */
export interface MerchantSearchResult {
    /**
     * 
     * @type {string}
     * @memberof MerchantSearchResult
     */
    _id: string;
    /**
     * 
     * @type {string}
     * @memberof MerchantSearchResult
     */
    name: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MerchantSearchResult
     */
    taxonomies?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof MerchantSearchResult
     */
    headerImage?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MerchantSearchResult
     */
    isOpen: boolean;
    /**
     * 
     * @type {Address}
     * @memberof MerchantSearchResult
     */
    address: Address;
    /**
     * 
     * @type {number}
     * @memberof MerchantSearchResult
     */
    distance?: number;
    /**
     * Extension to the URL on the DevourGO webpage.
     * @type {string}
     * @memberof MerchantSearchResult
     */
    url?: string;
    /**
     * See moment.tz.names()
     * @type {string}
     * @memberof MerchantSearchResult
     */
    timeZone: string;
    /**
     * 
     * @type {PhoneNumber}
     * @memberof MerchantSearchResult
     */
    phoneNumber: PhoneNumber;
    /**
     * 
     * @type {number}
     * @memberof MerchantSearchResult
     */
    prepTime: number;
    /**
     * 
     * @type {number}
     * @memberof MerchantSearchResult
     */
    distanceDeliveryMax?: number;
    /**
     * 
     * @type {number}
     * @memberof MerchantSearchResult
     */
    suspendUntil?: number;
    /**
     * 
     * @type {Array<BusinessServiceAvailability>}
     * @memberof MerchantSearchResult
     */
    serviceAvailabilities: Array<BusinessServiceAvailability>;
    /**
     * 
     * @type {Array<HandoffOptions>}
     * @memberof MerchantSearchResult
     */
    handoffOptions?: Array<HandoffOptions>;
    /**
     * 
     * @type {Array<OrderDiscountSearchEssential>}
     * @memberof MerchantSearchResult
     */
    promos: Array<OrderDiscountSearchEssential>;
    /**
     * 
     * @type {Array<MenuItemSearchEssential>}
     * @memberof MerchantSearchResult
     */
    secretMenuItems: Array<MenuItemSearchEssential>;
}

/**
 * Check if a given object implements the MerchantSearchResult interface.
 */
export function instanceOfMerchantSearchResult(value: object): value is MerchantSearchResult {
    if (!('_id' in value) || value['_id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('isOpen' in value) || value['isOpen'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('timeZone' in value) || value['timeZone'] === undefined) return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined) return false;
    if (!('prepTime' in value) || value['prepTime'] === undefined) return false;
    if (!('serviceAvailabilities' in value) || value['serviceAvailabilities'] === undefined) return false;
    if (!('promos' in value) || value['promos'] === undefined) return false;
    if (!('secretMenuItems' in value) || value['secretMenuItems'] === undefined) return false;
    return true;
}

export function MerchantSearchResultFromJSON(json: any): MerchantSearchResult {
    return MerchantSearchResultFromJSONTyped(json, false);
}

export function MerchantSearchResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): MerchantSearchResult {
    if (json == null) {
        return json;
    }
    return {
        
        '_id': json['_id'],
        'name': json['name'],
        'taxonomies': json['taxonomies'] == null ? undefined : json['taxonomies'],
        'headerImage': json['headerImage'] == null ? undefined : json['headerImage'],
        'isOpen': json['isOpen'],
        'address': AddressFromJSON(json['address']),
        'distance': json['distance'] == null ? undefined : json['distance'],
        'url': json['url'] == null ? undefined : json['url'],
        'timeZone': json['timeZone'],
        'phoneNumber': PhoneNumberFromJSON(json['phoneNumber']),
        'prepTime': json['prepTime'],
        'distanceDeliveryMax': json['distanceDeliveryMax'] == null ? undefined : json['distanceDeliveryMax'],
        'suspendUntil': json['suspendUntil'] == null ? undefined : json['suspendUntil'],
        'serviceAvailabilities': ((json['serviceAvailabilities'] as Array<any>).map(BusinessServiceAvailabilityFromJSON)),
        'handoffOptions': json['handoffOptions'] == null ? undefined : ((json['handoffOptions'] as Array<any>).map(HandoffOptionsFromJSON)),
        'promos': ((json['promos'] as Array<any>).map(OrderDiscountSearchEssentialFromJSON)),
        'secretMenuItems': ((json['secretMenuItems'] as Array<any>).map(MenuItemSearchEssentialFromJSON)),
    };
}

export function MerchantSearchResultToJSON(json: any): MerchantSearchResult {
    return MerchantSearchResultToJSONTyped(json, false);
}

export function MerchantSearchResultToJSONTyped(value?: MerchantSearchResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        '_id': value['_id'],
        'name': value['name'],
        'taxonomies': value['taxonomies'],
        'headerImage': value['headerImage'],
        'isOpen': value['isOpen'],
        'address': AddressToJSON(value['address']),
        'distance': value['distance'],
        'url': value['url'],
        'timeZone': value['timeZone'],
        'phoneNumber': PhoneNumberToJSON(value['phoneNumber']),
        'prepTime': value['prepTime'],
        'distanceDeliveryMax': value['distanceDeliveryMax'],
        'suspendUntil': value['suspendUntil'],
        'serviceAvailabilities': ((value['serviceAvailabilities'] as Array<any>).map(BusinessServiceAvailabilityToJSON)),
        'handoffOptions': value['handoffOptions'] == null ? undefined : ((value['handoffOptions'] as Array<any>).map(HandoffOptionsToJSON)),
        'promos': ((value['promos'] as Array<any>).map(OrderDiscountSearchEssentialToJSON)),
        'secretMenuItems': ((value['secretMenuItems'] as Array<any>).map(MenuItemSearchEssentialToJSON)),
    };
}

